import type { JSX } from 'react';

import { Typography } from '@mui/material';
import { ApplicationSuite } from 'common/types/Entities';

export const displayAppSuiteOptionMenuItemContent = (option: ApplicationSuite): JSX.Element => {
    return (
        <Typography>
            {option.name}
        </Typography>
    );
};
